import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import selfServicesService from "./selfServicesService";
import {
    DashboardBalances,
    UserInfoI,
    RelationshipI,
    DepartmentI,
    BankI,
    UpdateEmployerDetailsI,
    MissingMonthsI,
    TrackBenefitI, SubscriptionGroupI
} from "../../interfaces";

interface SelfServiceStateI {
    isLoading: boolean;
    isSuccessful: boolean;
    allEmployer: any;
    allPFA: any;
    allBanks: BankI;
    isDashboardLoading: boolean;
    isDashboardSuccessful: boolean;
    dashboardBalances: DashboardBalances;
    recaptureLink: string;
    userInfo: UserInfoI;
    nextOfKin: any;
    relationships: RelationshipI[];
    employerBranchDetails: any;
    pdoInformation: any;
    allDocumentDefinitions:any;
    departments: DepartmentI[],
    benefitEligibility: any;
    allEmployerBranch: any[],
    missingMonths: MissingMonthsI,
    trackBenefit: TrackBenefitI[],
    privacyStatus: any;
    subscriptionGroup: SubscriptionGroupI[],
}


const initialState: SelfServiceStateI = {
    isLoading: false,
    isSuccessful: false,
    allEmployer: [],
    allPFA: [],
    allDocumentDefinitions:[],
    allBanks: {
        banks: {}
    },
    privacyStatus:{},
    isDashboardLoading: false,
    isDashboardSuccessful: false,
    dashboardBalances: {
        currentValue: "",
        unitPrice: "",
        netContribution: "",
        totalUnits: "",
        totalContribution: "",
        growth: "",
        vcCurrentValue: "",
        vcUnitPrice: "",
        vcNetContribution: "",
        vcTotalUnits: "",
        vcGrowth: "",
        vcTotalContribution: ""
    },
    recaptureLink: "",
    userInfo: {
        age: 0,
        firstname: "",
        surname: "",
        othername: "",
        email: "",
        mobileNumber: "",
        house_Plot_No: "",
        streetName: "",
        city: "",
        state: "",
        stateCode: "",
        localGovernment: "",
        gender: "",
        employerName: ""
    },
    nextOfKin: null,
    relationships: [],
    employerBranchDetails: {},
    pdoInformation: {},
    departments: [],
    benefitEligibility: {},
    allEmployerBranch: [],
    missingMonths: {
        missingmonths: [],
        txtname: "",
        lastcontribution: "",
        lastContributionDate: "",
        lastPayingEmployer: "",
    },
    trackBenefit: [],
    subscriptionGroup: [],
};

export const transferRSA = createAsyncThunk(
    "selfService/transferRSA",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.transferRSA(data);

            console.log('transfer rsa',response);
            if (response?.status === 200) {
                toast.success(response?.data.message);
               
            } else {
                toast.error(response?.data?.errors.title);
                return {
                    isSuccessful: false,
                    data: response?.data?.errors.title
                }
            }

            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            return err?.response?.data;
        }
    }
);

export const getAllEmployer = createAsyncThunk(
    "selfService/getAllEmployer",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getAllEmployer(data);
            return response.data?.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);

export const getAllPFA = createAsyncThunk(
    "selfService/getAllPFA",
    async (data, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getAllPFA();
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);


export const getBanks = createAsyncThunk(
    "selfService/getBanks",
    async (data, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getBanks();
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);





export const getAggregators = createAsyncThunk(
    "selfService/aggregator",
    async (data, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getAggregators();
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);


export const getDashboardBalances = createAsyncThunk(
    "selfService/getDashboardBalances",
    async (data, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getDashboardBalances(data);
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);

export const getKYCStatus = createAsyncThunk(
    "selfService/getKYCStatus",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getKYCStatus(data);
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);

export const validateEmail = createAsyncThunk(
    "selfService/validateEmail",
    async (data, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.validateEmail();
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            return err?.response?.data;
        }
    }
);

export const verifyEmail = createAsyncThunk(
    "selfService/verifyEmail",
    async (data:{ verificationCode: string }, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.verifyEmailAddress(data);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            return err?.response?.data;
        }
    }
);

export const validatePhoneNumber = createAsyncThunk(
    "selfService/validatePhoneNumber",
    async (data, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.validatePhoneNumber();
            console.log('the response na ', response)
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            return err?.response?.data;
        }
    }
);

export const verifyPhoneNumber = createAsyncThunk(
    "selfService/verifyPhoneNumber",
    async (data:{ verificationCode: string }, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.verifyPhoneNumber(data);
            if (response.status === 200) {
                toast.success(response?.data.message);
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const generateRecaptureLink = createAsyncThunk(
    "selfService/generateRecaptureLink",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.generateRecaptureLink(data);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data?.responseObject?.link;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const UpdateKYC = createAsyncThunk(
    "selfService/UpdateKYC",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.updateKYC(data);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const GetUserInfo = createAsyncThunk(
    "selfService/GetUserInfo",
    async (_, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getUserInfo();
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);

               
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const CreateNextOfKin = createAsyncThunk(
    "selfService/CreateNextOfKin",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.createNextOfKin(data);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const UpdateNextOfKin = createAsyncThunk(
    "selfService/UpdateNextOfKin",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.updateNextOfKin(data);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }

            if (response?.data?.statusCode === "00") {
                toast.success(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const GetNextOfKin = createAsyncThunk(
    "selfService/GetNextOfKin",
    async (_, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getNextOfKin();
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const GetRelationship = createAsyncThunk(
    "selfService/GetRelationship",
    async (_, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getRelationship();
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const GetEmployerBranchDetails = createAsyncThunk(
    "selfService/GetEmployerBranchDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getEmployerBranchDetails();
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const EmployerConfirmation = createAsyncThunk(
    "selfService/EmployerConfirmation",
    async (_, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.employerConfirmation();
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage);
            }
            else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const GetAllEmployerBranch = createAsyncThunk(
    "selfService/GetAllEmployerBranch",
    async (payload: {employerId: number}, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getallemployerbranch(payload.employerId);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const GetDocumentDefinitions = createAsyncThunk(
    "selfService/getdocumentdefinitions",
    async (payload: {searchText:string}, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getdocumentdefinitions(payload.searchText);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const UpdateEmployerDetails = createAsyncThunk(
    "selfService/UpdateEmployerDetails",
    async (payload: FormData, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.updateemployerdetails(payload);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const PDO = createAsyncThunk(
    "selfService/PDO",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.pdo(payload);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage);
            }else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const GetDepartment = createAsyncThunk(
    "selfService/GetDepartment",
    async (_, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getDepartment();
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const CheckBenefitEligibility = createAsyncThunk(
    "selfService/CheckBenefitEligibility",
    async (payload: {type: number}, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.checkBenefitEligibility(payload);
            if (response.status === 200) {
                toast.success(response?.data?.responseObject[0])
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const InitiateBenefitsApplication = createAsyncThunk(
    "selfService/InitiateBenefitsApplication",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.initiateBenefitsApplication(payload);
            if (response.status === 200) {
                toast.success(response?.data?.responseObject)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const PensionCalculator = createAsyncThunk(
    "selfService/PensionCalculator",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.pensionCalculator(payload);
            if (response.status === 200) {
                toast.success(response?.data?.responseObject)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
          console.log('error na ', error)
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);




export const AcceptPrivacyPolicy = createAsyncThunk(
    "SelfServices/privacy",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.AcceptPrivacyPolicy(payload);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
          console.log('error na ', error)
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);




export const RetireePensionCalculator = createAsyncThunk(
    "selfService/RetireePensionCalculator",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.retireePensionCalculator(payload);
            if (response.status === 200) {
                toast.success(response?.data?.responseObject)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const MyMemorableDays = createAsyncThunk(
    "selfService/MyMemorableDays",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.myMemorableDays(payload);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const VirtualNin = createAsyncThunk(
    "selfService/VirtualNin",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.virtualNin(payload);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);



export const Mpppay = createAsyncThunk(
    "selfService/mpppay",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.mpppay(payload);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const MissingMonths = createAsyncThunk(
    "selfService/MissingMonths",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.missingMonths(data);
            if (response.status === 200) {
                toast.success(response?.data?.responseObject)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const FundTransfer = createAsyncThunk(
    "selfService/FundTransfer",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.fundTransfer(data);
            if (response.status === 200) {
                if(response.data.statusMessage.startsWith("You have a pending request")){
                    toast.error(response?.data?.statusMessage);
                } else {
                    toast.success(response?.data?.statusMessage);
                }
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const CompleteFundTransfer = createAsyncThunk(
    "selfService/CompleteFundTransfer",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.completeFundTransfer(data);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const TrackBenefit = createAsyncThunk(
    "selfService/TrackBenefit",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.trackBenefit(data);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const CheckBenefitStatus = createAsyncThunk(
    "selfService/benefitstatus",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.benefitStatus(data);
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const ChangePasscode = createAsyncThunk(
    "selfService/ChangePasscode",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.updatePasscode(data);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage);
            }
            else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ title: string }>;
            toast.error(err.response?.data.title);
            return err.response?.data;
        }
    }
);




export const GetPasscode = createAsyncThunk(
    "selfService/GetPasscode",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getOldPasscode(data);
            if (response.status === 200) {

           //     responseObject.passcode
                // toast.success(response?.data?.statusMessage);
            }
            else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ title: string }>;
            toast.error(err.response?.data.title);
            return err.response?.data;
        }
    }
);

export const ChangePassword = createAsyncThunk(
    "selfService/ChangePassword",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.changePassword(data);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage);
            }
            else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const GetSubscriptionGroup = createAsyncThunk(
    "selfService/GetSubscriptionGroup",
    async (_, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.getSubscriptionGroup();
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const SubscriptionGroup = createAsyncThunk(
    "selfService/SubscriptionGroup",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.subscriptionGroup(data);
            if (response.status === 200) {
                 toast.success(response?.data?.statusMessage);
            
            }
            if (response.status !== 200) {
                // toast.success(response?.data?.statusMessage);
            // }
            // else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const UpdateBiodata = createAsyncThunk(
    "selfService/UpdateBiodata",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.updateBiodata(data);
            if (response.status !== 200) {
                // toast.success(response?.data?.statusMessage);
            // }
            // else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);


export const Privacy = createAsyncThunk(
    "selfServices/Privacy",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.privacy(data);
            if (response.status !== 200) {
                // toast.success(response?.data?.statusMessage);
            // }
            // else {
                toast.error(response?.data?.statusMessage);
            }
            return response;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);




export const GetPrivacyPolicyStatus = createAsyncThunk(
    "selfServices/getPrivacy",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.GetPrivacyPolicyStatus(data);
            if (response.status === 200) {
               // toast.success(response?.data?.responseObject)
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);

export const CORGRequest = createAsyncThunk(
    "selfService/CORGRequest",
    async (data:any, { rejectWithValue }) => {
        try {
            const response = await selfServicesService.CORGRequest(data);
            if (response.status === 200) {
                toast.success(response?.data?.statusMessage);
            }
            else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ statusMessage: string }>;
            toast.error(err.response?.data.statusMessage);
            rejectWithValue(err.response?.data.statusMessage)
        }
    }
);





export const selfServiceSlice = createSlice({
    name: "selfService",
    initialState,
    reducers: {
        noTract: () => {},
    },
    extraReducers: (builder) => {
        builder
            .addCase(transferRSA.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
    
            .addCase(transferRSA.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true
                };
            })
            .addCase(transferRSA.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })









            .addCase(Mpppay.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
    
            .addCase(Mpppay.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true
                };
            })
            .addCase(Mpppay.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })

            .addCase(getAllEmployer.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(getAllEmployer.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    allEmployer: action.payload,
                };
            })
            .addCase(getAllEmployer.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(getAllPFA.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(getAllPFA.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    allPFA: action.payload,
                };
            })
            .addCase(getAllPFA.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(getBanks.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(getBanks.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    allBanks: action.payload,
                };
            })
            .addCase(getBanks.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(getDashboardBalances.pending, (state, action) => {
                return {
                    ...state,
                    isDashboardLoading: true,
                    isDashboardSuccessful: false,
                };
            })
            .addCase(getDashboardBalances.fulfilled, (state, action) => {
                return {
                    ...state,
                    isDashboardLoading: false,
                    isDashboardSuccessful: true,
                    dashboardBalances: action.payload,
                };
            })
            .addCase(getDashboardBalances.rejected, (state, action) => {
                return {
                    ...state,
                    isDashboardLoading: false,
                    isDashboardSuccessful: false,
                };
            })
            .addCase(getKYCStatus.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(getKYCStatus.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(getKYCStatus.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(validateEmail.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(validateEmail.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(validateEmail.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(verifyEmail.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(verifyEmail.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(verifyEmail.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(validatePhoneNumber.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(validatePhoneNumber.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(validatePhoneNumber.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(verifyPhoneNumber.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(verifyPhoneNumber.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(verifyPhoneNumber.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(generateRecaptureLink.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(generateRecaptureLink.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    recaptureLink: action.payload
                };
            })
            .addCase(generateRecaptureLink.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(UpdateKYC.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(UpdateKYC.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(UpdateKYC.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(GetUserInfo.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetUserInfo.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    userInfo: action.payload
                };
            })
            .addCase(GetUserInfo.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(GetNextOfKin.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetNextOfKin.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    nextOfKin: action.payload
                };
            })
            .addCase(GetNextOfKin.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(UpdateNextOfKin.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(UpdateNextOfKin.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(UpdateNextOfKin.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(CreateNextOfKin.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(CreateNextOfKin.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(CreateNextOfKin.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(GetRelationship.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetRelationship.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    relationships: action.payload
                };
            })
            .addCase(GetRelationship.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(GetEmployerBranchDetails.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetEmployerBranchDetails.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    employerBranchDetails: action.payload
                };
            })
            .addCase(GetEmployerBranchDetails.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(EmployerConfirmation.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(EmployerConfirmation.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(EmployerConfirmation.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(UpdateEmployerDetails.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(UpdateEmployerDetails.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(UpdateEmployerDetails.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(GetAllEmployerBranch.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetAllEmployerBranch.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    allEmployerBranch: action.payload,
                };
            })
            .addCase(GetAllEmployerBranch.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })



            .addCase(GetDocumentDefinitions.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetDocumentDefinitions.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    allDocumentDefinitions: action.payload,
                };
            })
            .addCase(GetDocumentDefinitions.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            
            .addCase(PDO.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(PDO.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    pdoInformation: action.payload
                };
            })
            .addCase(PDO.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(GetDepartment.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetDepartment.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    departments: action.payload
                };
            })
            .addCase(GetDepartment.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(CheckBenefitEligibility.pending, (state, action) => {
              console.log('action naa', action);
              return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(CheckBenefitEligibility.fulfilled, (state, action) => {
              console.log('action naa', action);
              return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    benefitEligibility: action.payload
                };
            })
            .addCase(CheckBenefitEligibility.rejected, (state, action) => {
              console.log('action naa', action);
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(InitiateBenefitsApplication.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(InitiateBenefitsApplication.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(InitiateBenefitsApplication.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(MyMemorableDays.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(MyMemorableDays.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(MyMemorableDays.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(VirtualNin.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(VirtualNin.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(VirtualNin.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(MissingMonths.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(MissingMonths.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    missingMonths: action.payload,
                };
            })
            .addCase(MissingMonths.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(PensionCalculator.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(PensionCalculator.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(PensionCalculator.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })





            .addCase(AcceptPrivacyPolicy.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(AcceptPrivacyPolicy.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(AcceptPrivacyPolicy.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })


            .addCase(GetPrivacyPolicyStatus.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetPrivacyPolicyStatus.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    privacyStatus: action.payload,
                };
            })
            .addCase(GetPrivacyPolicyStatus.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })


            




            
            .addCase(RetireePensionCalculator.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(RetireePensionCalculator.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(RetireePensionCalculator.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(FundTransfer.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(FundTransfer.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(FundTransfer.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(CompleteFundTransfer.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(CompleteFundTransfer.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(CompleteFundTransfer.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(TrackBenefit.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(TrackBenefit.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    trackBenefit: action.payload,
                };
            })
            .addCase(TrackBenefit.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(ChangePasscode.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(ChangePasscode.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(ChangePasscode.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(ChangePassword.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(ChangePassword.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(ChangePassword.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(GetSubscriptionGroup.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetSubscriptionGroup.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    subscriptionGroup: action.payload,
                };
            })
            .addCase(GetSubscriptionGroup.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(SubscriptionGroup.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(SubscriptionGroup.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(SubscriptionGroup.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(UpdateBiodata.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(UpdateBiodata.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(UpdateBiodata.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(Privacy.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(Privacy.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(Privacy.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })
            .addCase(CORGRequest.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(CORGRequest.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                };
            })
            .addCase(CORGRequest.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            });
    },
});

export default selfServiceSlice.reducer;